import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, IconButton, Menu, MenuItem, Radio, RadioGroup } from '@homeexchange/panorama';

import i18n from '../../../i18n';

export const SORT_OPTIONS = ['relevance', 'newest', 'most_recent_availabilities'];
const DEFAULT_SORT = SORT_OPTIONS[0];

const sortTitle = () => i18n.t('search:sort_by_title').replace(/\s*:\s*$/, '');
const optionLabel = (option) => i18n.t(`search:sort_by_${option}`);

const SortOrderSheet = ({ value, onChange, asMenu }) => {
    const [isOpen, setIsOpen] = useState(false);
    const current = SORT_OPTIONS.includes(value) ? value : DEFAULT_SORT;
    const buttonProps = { hierarchy: 'secondary', size: 'medium' };

    const select = (next) => {
        setIsOpen(false);
        if (next !== current) {
            onChange({ name: 'sort', id: 'sort_type', type: 'select-one', value: next });
        }
    };

    if (asMenu) {
        return (
            <Menu
                align="start"
                trigger={
                    <Button icon="ArrowsDiagonal" type="button" {...buttonProps}>
                        {`${i18n.t('search:sort_by_title')} ${optionLabel(current)}`}
                    </Button>
                }
            >
                {SORT_OPTIONS.map((option) => (
                    <MenuItem
                        key={option}
                        label={optionLabel(option)}
                        isSelected={option === current}
                        onClick={() => select(option)}
                    />
                ))}
            </Menu>
        );
    }

    return (
        <>
            <IconButton
                icon="ArrowsDiagonal"
                label={sortTitle()}
                onClick={() => setIsOpen(true)}
                type="button"
                {...buttonProps}
            />
            <Dialog
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title={sortTitle()}
                closeLabel={i18n.t('common:close')}
            >
                <RadioGroup aria-label={sortTitle()} name="sort" value={current} onValueChange={select}>
                    {SORT_OPTIONS.map((option) => (
                        <Radio key={option} value={option} label={optionLabel(option)} />
                    ))}
                </RadioGroup>
            </Dialog>
        </>
    );
};

SortOrderSheet.propTypes = {
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onChange: PropTypes.func.isRequired,
    asMenu: PropTypes.bool
};

export default SortOrderSheet;
